import { useEffect, useState, useRef } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
//import { io } from "socket.io-client";
//import socket from './Core/socket';
//import Footer from './Components/Footer';
//import Login from './Pages/Public/Login';
import Home from './Pages/Public/Home';
//import MemberHome from './Pages/Private/MemberHome';
import Privacy from './Pages/Public/Privacy';
import Terms from './Pages/Public/Terms';
import Products from './Pages/Public/Products';
import WhyHerdr from './Pages/Public/WhyHerdr';
import Team from './Pages/Public/Team';
import Pricing from './Pages/Public/Pricing';
import RemoteTeams from './Pages/Public/RemoteTeams';
import TechStartupFounder from './Pages/Public/TechStartupFounder';
import CompanyExecutives from './Pages/Public/CompanyExecutives';
import ProductDesigner from './Pages/Public/ProductDesigner';
import CreativeAgency from './Pages/Public/CreativeAgency';
import Freelancer from './Pages/Public/Freelancer';
import BootstrappedEntrepreneur from './Pages/Public/BootstrappedEntrepreneur';
import NonProfit from './Pages/Public/NonProfit';
import AcademicResearchTeam from './Pages/Public/AcademicResearchTeam';
import SoftwareDevelopmentTeam from './Pages/Public/SoftwareDevelopmentTeam';
import ConsultantCoach from './Pages/Public/ConsultantCoach';
import EcommerceTeam from './Pages/Public/EcommerceTeam';
import RoadmapInvite from './Pages/Public/RoadmapInvite';
import NotFound404 from './Pages/Public/NotFound404';
import Login from './Pages/Public/Login';
import Register from './Pages/Public/Register';
import Forgot from './Pages/Public/Forgot';
import Recover from './Pages/Public/Recover';
import Dash from './Pages/Private/Dash';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css'
import { ToastContainer } from 'react-toastify';
import { refreshAccessToken, getUser, getAvatar, setAvatar, setAuthStatus } from './Store/Auth';
import { getRoadmap, getRoadmaps, getRoadmapCards, getRoadmapCategories, 
  getMembers, setRoadmapStatus, setRoadmaps, setRoadmapCards, 
  setCategories,
  setMembers,
  loadRoadmap
} from './Store/Roadmap';
import { getRoadmapFolders, getWorkFolders } from './Store/Folder';
import { getProjects, getProject, getLists, getCards, getComments, 
  getLabelsToCards, getLabels, setComments, setCards, setLists, setLabels, 
  setLabelsToCards, setProjectStatus, setProjects,
  setProjectCardWorkLogEntries,
  getProjectCardWorkLogEntries,
  getListSettings,
  loadProject
} from './Store/Project';
import { getUserSettings, heartBeat, loadComponent } from './Store/Settings';
import { useAppSelector, useAppDispatch } from './Core/hooks';
import { getFolder, setFolderStatus } from './Store/Folder';
import { getSettings, setSocket } from './Store/Settings';
//import { openSocket } from './Helpers/openSocket';
import { Channel } from './Models/Channel';
import { getChat, setChannels, setFindMembers, setMembersOnline, 
  setAllChatMembers, setMessages, setTyping, 
  loadChannel} from './Store/Chat';
import { openSocket } from './Helpers/openSocket';
import { io } from 'socket.io-client';
import { Socket } from 'socket.io-client';
import { Member } from './Models/Requests/Member';
import { Message } from './Models/Message';
import { getPlans, getMostRecentPayment } from './Store/Stripe';
import { MComment } from './Models/MComment';
import { ProjectCard } from './Models/ProjectCard';
import { Project } from './Models/Project';
import { ProjectList } from './Models/ProjectList';
import { Label } from './Models/Label';
import { LabelToCard } from './Models/LabelToCard';
import { Roadmap } from './Models/Roadmap';
import { RoadmapCard } from './Models/RoadmapCard';
import { RoadmapCategory } from './Models/RoadmapCategory';
import Mouseflow from './Pages/Public/Mouseflow';
import { status } from './Helpers/types';
import { ProjectCardWorkLog } from './Models/ProjectCardWorkLog';
import { useIsMobile } from './Core/hooks';

interface ComponentProps {
  children ?: React.ReactNode;
}

type Props = ComponentProps;

function App(props: Props) {
  
  const dispatch = useAppDispatch();
  const userState = useAppSelector(getUser);
  //const chatState = useAppSelector(getChat);
  const folderState = useAppSelector(getFolder);
  const roadmapState = useAppSelector(getRoadmap);
  const projectState = useAppSelector(getProject);
  const settingsState = useAppSelector(getSettings);
  const chatState = useAppSelector(getChat);
  const chatStateRef = useRef(chatState);
  const userStateRef = useRef(userState);
  const projectStateRef = useRef(projectState);
  const roadmapStateRef = useRef(roadmapState);
  const settingsStateRef = useRef(settingsState);
  const isMobile = useIsMobile();

  //const [socket, setSocket] = useState<any>(null);
  //const settingsStateRef = useRef(settingsState);

  //let socket: any = null; // Store socket instance outside component to avoid re-creating it
/*
    useEffect(() => {
        settingsStateRef.current = settingsState;
    }, [settingsState]);
*/

  useEffect(() => {
    let socket = openSocket(dispatch, settingsState);
    if (socket) {
      socket.emit("getAllChatMembers");
    }
  }, []);

  useEffect(() => {
    if (userState.status === "loggedIn") {
      let socket = openSocket(dispatch, settingsState);
      if (socket) {
        socket.emit("getAllChatMembers");
        console.log("Invite Accepted");
        console.log(userState.acceptedInvite);
        console.log(userState.inviteRoadmapId);
        if (userState.acceptedInvite) {
          socket.emit("getRoadmapMembers", { roadmapId: userState.inviteRoadmapId });
        }
      }
      dispatch(setAuthStatus("idle"));
    }
  }, [userState.status]);

  useEffect(() => {
      chatStateRef.current = chatState;
  }, [chatState]);

  useEffect(() => {
      userStateRef.current = userState;
  }, [userState]);

  useEffect(() => {
    projectStateRef.current = projectState;
  }, [projectState]);

  useEffect(() => {
    roadmapStateRef.current = roadmapState;
  }, [roadmapState]);

  useEffect(() => {
    settingsStateRef.current = settingsState;
  }, [settingsState]);

  useEffect (() => {
    dispatch(refreshAccessToken());
    dispatch(getPlans()); /* public pages */
    /* hearbeat to stay logged in */
   // window.setInterval(() => {
      //dispatch(heartBeat());
      //openSocket(dispatch, settingsStateRef);
    //}, 60000);
    /* moved to topnav with version. Separately, it causes cronic logouts
    const intervalId = setInterval(() => {
      dispatch(heartBeat());
    }, 60000);
    return () => clearInterval(intervalId);
    */
  },[]);

  useEffect (() => {
    if (userState.accessToken !== "" && roadmapState.roadmaps.length === 0) {
      dispatch(getAvatar());
      //dispatch(getPlans());
      dispatch(getRoadmapFolders());
      //dispatch(getRoadmaps());
      dispatch(getUserSettings());
    }
  }, [userState.accessToken]);

  useEffect (() => {
    if (userState.accessToken !== "") {
      //console.log("token changed");
      dispatch(getAvatar());
      dispatch(getMostRecentPayment());
      dispatch(getRoadmapFolders());
      dispatch(getUserSettings());

      /* This worked well, but Kevin still experiencing issues and I did once on 
         localhost, so trying to further improve. Put this back in place if this change
         goes wrong av 6/5/25 6am
      if (settingsState.socket && settingsState.socket.connected) {
        settingsState.socket.disconnect();
      }
      */
     /* av 6/5/25 6am - attempt to remove chance of stale jwt in old socket
        on token refresh.
      */
      if (settingsState.socket) {
        // Fully disable reconnection logic
        settingsState.socket.io.opts.autoConnect = false;
        // Remove all listeners to prevent stale callbacks
        settingsState.socket.removeAllListeners();
        // Disconnect and destroy the socket
        settingsState.socket.disconnect();
      }

      let socket = openSocket(dispatch, settingsState);
      if (socket) {
        /* 
        socket.on("disconnect", (reason: any) => {
          console.log("Socket disconnected:", reason);
          socket.removeAllListeners(); // safety
        });
        */
        socket.on("disconnect", (reason: any) => {
          console.warn("Socket disconnected:", reason);
        
          if (reason === "transport close") {
            console.warn("Force-replacing socket after 'transport close'...");
        
            //socket.disconnect();
            //socket.removeAllListeners();
            //socket.close();
            /*
            const replacement = io(process.env.REACT_APP_BACKEND_URL!, {
              transports: ["websocket"],
              forceNew: true,
              reconnection: false,
              autoConnect: true,
              withCredentials: true,
              timeout: 2000
            });
            */
            let newSocket = openSocket(dispatch, settingsState);
            dispatch(setSocket(newSocket));
          }
        });
        

        socket.on("connect", () => {

          socket.emit("getChannels");
          socket.emit("getAllChatMembers");

          socket.on("logProjectCardWorkTimeBroadcast", (userId: string, logEntry: ProjectCardWorkLog, cardUpdated: boolean, updatedCard: ProjectCard) => {
            let entries = [...projectStateRef.current?.projectCardWorkLog];
            let index = entries.findIndex(e => e._id === logEntry._id);
            if (index === -1) {
              entries.push(logEntry);
              dispatch(setProjectCardWorkLogEntries(entries));
              if (cardUpdated) {
                let cards = [...projectStateRef.current?.cards];
                let index = cards.findIndex(c => c._id === updatedCard._id);
                if (index !== -1) {
                  cards[index] = updatedCard;
                  dispatch(setCards(cards));
                  dispatch(setProjectStatus("workChanged"));
                }
              }
            }
          });

          //socket.off("deleteChannelBroadcast");
          socket.on("deleteChannelBroadcast", (userId: string, channelType: string, id: string) => {
            /* If a channel was deleted, delete for all users, but if a direct message was deleted,
               only delete for the user deleting it.
            */
            if (channelType === "channel" || 
              (channelType === "direct message" && userStateRef.current?._id === userId)) {
              let channels = [...chatStateRef.current?.channels];
              let index = channels.findIndex(c => c._id === id);
              if (index !== -1) {
                channels.splice(index,1);
                dispatch(setChannels(channels));
              }
            }
          });

          //socket.off("deleteMessageBroadcast");
          socket.on("deleteMessageBroadcast", (id: string) => {
            let messages = [...chatStateRef.current?.messages];
            let index = messages.findIndex(m => m._id === id);
            if (index !== -1) {
              messages.splice(index,1);
              dispatch(setMessages(messages));
            }
          });

          //socket.off("sendMessageBroadcast");
          socket.on("sendMessageBroadcast", (message: Message) => {
            //console.log("message received");
            socket.emit("getChannels"); /* could have been direct message channels added */
            let channels = [...chatStateRef.current?.channels];
            let index = channels.findIndex(c => c._id === message.channelId);
            if (index !== -1) {
              let messages = [...chatStateRef.current?.messages];
              let index = messages.findIndex(m => m._id === message._id);
              if (index === -1) {
                messages.push(message);
                dispatch(setMessages(messages));
              }
            }
          }); 
          
          //socket.off("getMessagesBroadcast");
          socket.on("getMessagesBroadcast", (userId: string, messages: Array<Message>) => {
            if (userStateRef.current?._id === userId) {
              dispatch(setMessages(messages));
            }
          }); 

          //socket.off("getChannelsBroadcast");
          socket.on("getChannelsBroadcast", (userId: string, channels: Array<Channel>) => {
            if (userStateRef.current?._id === userId) {
              
              let fullName = userStateRef.current?.firstName.charAt(0).toUpperCase() + userStateRef.current?.firstName.slice(1) + " " +
              userStateRef.current?.lastName.charAt(0).toUpperCase() + userStateRef.current?.lastName.slice(1);
              
              let renamedChannels = channels.map(channel => {
                if (channel.type === "direct message" && channel.name.includes(fullName)) {
                    let name = channel.name.replace(fullName, "Me");
                    return {...channel, name: name };
                } else {
                  return channel;
                }
              });

              dispatch(setChannels(renamedChannels));
            }
          }); 
          
          //socket.off("createChannelBroadcast");
          socket.on("createChannelBroadcast", async (userId: string, channel: Channel, newChannel: boolean) => {
            if (userStateRef.current?._id === userId || 
              (newChannel && channel.members.some(u => u.userId === userStateRef.current?._id))) {
              let channels = [...chatStateRef.current?.channels];

              // If direct message, remove current user from name
              let formattedChannel: Channel = {...channel};
              let fullName = userStateRef.current?.firstName.charAt(0).toUpperCase() + userStateRef.current?.firstName.slice(1) + " " +
                userStateRef.current?.lastName.charAt(0).toUpperCase() + userStateRef.current?.lastName.slice(1);

              if (channel.type === "direct message" && channel.name.includes(fullName)) {
                  //let nameCheck1 = ", " + fullName;
                  //let nameCheck2 = fullName + ", ";
                  //let name = channel.name.replace(nameCheck1, "");
                  //name = name.replace(nameCheck2, "");
                  let name = channel.name.replace(fullName, "Me");
                  formattedChannel = {...channel, name: name };
              }

              //channels.push(formattedChannel);
              //dispatch(setChannels(channels));

              const exists = channels.some(c => c._id === formattedChannel._id);
              if (!exists) {
                channels.push(formattedChannel);
                await dispatch(setChannels(channels));

                /* If user is on mobile and created a channel, load it */
                if (isMobile && userStateRef.current?._id === userId) {
                  dispatch(loadChannel(channel._id));
                }

              }
            }
          });

          //socket.off("saveChannelBroadcast");
          socket.on("saveChannelBroadcast", (userId: string, channel: Channel) => {
            if (userStateRef.current?._id === userId || channel.members.some(u => u.userId === userStateRef.current?._id)) {
              let channels = [...chatStateRef.current?.channels];
              let index = channels.findIndex(c => c._id === channel._id);
              if (index !== -1) {
                //channels.push(channel);
                channels[index] = channel;
                dispatch(setChannels(channels));
              }
            }
          });
          
          //socket.off("getAllChatMembersBroadcast");
          socket.on("getAllChatMembersBroadcast", (userId: string, members: Array<Member>) => {
            if (userStateRef.current?._id === userId) {
              dispatch(setAllChatMembers(members));
            }
          }); 

          socket.on("getRoadmapMembersBroadcast", (roadmapId: string, members: Array<Member>) => {
            /* This entire function is for when someone invites a user to their roadmap and 
               sets on the members screen. If the user accepts the invite, we want the other
               user's screen to auto-update without a refresh.
             */
            let loadedRoadmap = roadmapStateRef.current?.roadmaps.find(r => roadmapId);
            if (loadedRoadmap) {
              let myself = members.find(m => m.userId === userStateRef.current?._id);
              let meIndex = members.findIndex(m => m.userId === userStateRef.current?._id);
              if (meIndex !== -1 && myself) {
                members[meIndex] = {...myself, me: true };  
              }
              dispatch(setMembers(members));
            }
          }); 

          

          //socket.off("getMembersBroadcast");
          socket.on("getMembersBroadcast", (userId: string, members: Array<any>) => {
            if (userStateRef.current?._id === userId) {
              dispatch(setFindMembers(members));
            }
          });

         //socket.off("userOnline");
          socket.on("userOnline", (fullName: string, _id: string) => {
            // Mark user as online in UI
            let membersOnline = [...chatStateRef.current?.membersOnline];
            let index = membersOnline.findIndex(mo => mo.fullName === fullName);
            if (index === -1) {
              membersOnline.push({ fullName: fullName, _id: _id });
              dispatch(setMembersOnline(membersOnline));
            }
          });

          //socket.off("userOffline");
          socket.on("userOffline", (fullName: string) => {
            // Mark user as offline in UI
            let membersOnline = [...chatStateRef.current?.membersOnline];
            let index = membersOnline.findIndex(m => m.fullName === fullName);
            if (index !== -1) {
              membersOnline.splice(index,1);
              dispatch(setMembersOnline(membersOnline));
            }
          });

          //socket.off("typing");
          socket.on("typing", (channelId: string, userId: string) => {
            let channel = chatStateRef.current?.channels.find(c => c.loaded);
            if ( channel && channelId === channel._id && userId !== userStateRef.current?._id) {
              let member = channel.members.find(m => m.userId === userId);
              if (member) {
                let names = [...chatStateRef.current?.typingNames];
                let index = names.findIndex(n => n === member!.firstName + " " + member!.lastName);
                if (index === -1) {
                  names.push(member!.firstName + " " + member!.lastName);
                }
                dispatch(setTyping({ typing: true, typingNames: names }));
              }
            }
          });

          //socket.off("stop typing");
          socket.on("stop typing", (channelId: string, userId: string) => {
            let channel = chatStateRef.current?.channels.find(c => c.loaded);
            if ( channel && channelId === channel._id && userId !== userStateRef.current?._id) {

              let member = channel.members.find(m => m.userId === userId);
              if (member) {
                let names = [...chatStateRef.current?.typingNames];
                let index = names.findIndex(n => n === member!.firstName + " " + member!.lastName);
                if (index !== -1) {
                  names.splice(index, 1);
                }
                dispatch(setTyping({ typing: false, typingNames: names }));
              }
            }
          });

          socket.on("saveCommentBroadcast", (userId: string, comment: MComment) => {
            let foundCard = projectStateRef.current?.cards.find(card => card._id === comment.cardId); 
            if (foundCard) {
              let comments = [...projectStateRef.current?.comments];
              const index = comments.findIndex(c => c._id === comment._id);
              if (index !== -1) {
                comments[index] = comment;
              } else {
                comments.unshift(comment);
              }
              dispatch(setComments(comments));
            }
          });

          socket.on("deleteCommentBroadcast", (userId: string, id: string) => {
            let comments = [...projectStateRef.current?.comments];
            let commentIndex = comments.findIndex(c => c._id === id);
            if (commentIndex !== -1) {
                comments.splice(commentIndex, 1);
                dispatch(setComments(comments));
            }
          });

          socket.on("createCardBroadcast", (userId: string, card: ProjectCard) => {
            let list = projectStateRef.current?.lists.find(list => list._id === card.listId);
            if (list) {
              let cards = [...projectStateRef.current?.cards];
              let index = cards.findIndex(c => c._id === card._id);
              if (index === -1) {
                cards.push(card);
                dispatch(setCards(cards));
              }
            }
          });

          socket.on("saveCardBroadcast", (userId: string, card: ProjectCard) => {
            let list = projectStateRef.current?.lists.find(list => list._id === card.listId);
            if (list) {
              let cards = [...projectStateRef.current?.cards];
              let index = cards.findIndex(c => c._id === card._id);
              if (index !== -1) {
                cards[index] = card;
                dispatch(setCards(cards));
                dispatch(setProjectStatus("workChanged"));
                /* update roadmap cards so progress bar updates if card was connected to roadmap item */
                /*
                let roadmapCard = roadmapStateRef.current?.cards.find(c => c._id === card.roadmapItem);
                if (roadmapCard) {
                  dispatch(getRoadmapCards(roadmapCard.roadmapId));
                }
                */
              }
            }
          });

          socket.on("copyCardBroadcast", (userId: string, projectId: string, cards: Array<ProjectCard>) => {
            if (cards.length > 0) {
              let project = projectStateRef.current?.projects.find(p => p._id === projectId);
              if (project) {
                dispatch(setCards(cards));
              }
            }
          });

          socket.on("copyListBroadcast", (userId: string, projectId: string, lists: Array<ProjectList>) => {
            if (lists.length > 0) {
              let project = projectStateRef.current?.projects.find(p => p._id === projectId);
              if (project) {
                dispatch(setLists(lists));
                if (userStateRef.current?._id === userId) {
                  // Delay setting status to ensure lists are in state
                  setTimeout(() => {
                      dispatch(setProjectStatus("listCopied"));
                  }, 0);
                }
              }
            }
          });

          socket.on("deleteCardBroadcast", (userId: string, cardId: string) => {
            const cards = projectStateRef.current?.cards.filter(c => c._id !== cardId);
            if (cards) {
              dispatch(setCards(cards));
            }
            dispatch(setProjectStatus("workChanged"));
            /* update roadmap cards so progress bar updates if card was connected to roadmap item */
            /*
            let roadmap = roadmapStateRef.current?.roadmaps.find(r => r.loaded);
            if (roadmap) {
              dispatch(getRoadmapCards(roadmap._id));
            }*/
          });

          socket.on("createProjectBroadcast", (userId: string, project: Project, usersWithAccess: Array<string>) => {
            const roadmap = projectStateRef.current?.projects.find(r => r._id !== project.roadmapId);
            if (roadmap) {
              if (usersWithAccess.some(u => u === userStateRef.current?._id)) {
                let projects = [...projectStateRef.current?.projects];
                let index = projects.findIndex(p => p._id === project._id);
                if (index === -1) {
                  projects.push(project);
                  dispatch(setProjects(projects));
                  /* if on mobile, load the project for the current user after it is created */
                 // if (isMobile && userId === userStateRef.current?._id) {
                  //  dispatch(loadProject(project._id));
                 // }
                }
              }
            }
          });

          socket.on("deleteProjectBroadcast", (userId: string, id: string) => {
            let projects = [...projectStateRef.current?.projects];
            let index = projects.findIndex(p => p._id === id);
            if (index !== -1) {
                projects.splice(index, 1);
                dispatch(setProjects(projects));
            }
          });

          socket.on("saveProjectBroadcast", (userId: string, id: string, name: string) => {
            //console.log("Project Name Saved");
            let projects = [...projectStateRef.current?.projects];
            let index = projects.findIndex(p => p._id === id);
            if (index !== -1) {
                //console.log("Project Name: " + name);
                projects[index] = {...projects[index], name: name };
                //projects[index].name = name;
                dispatch(setProjects(projects));
            }
          });

          socket.on("createListBroadcast", (userId: string, projectId: string,lists: Array<ProjectList>) => {
            if (lists.length > 0) {
              let project = projectStateRef.current?.projects.find(p => p._id === projectId);
              if (project) {
                dispatch(setLists(lists));
                dispatch(setProjectStatus("listAdded"));
              }
            }
          });

          socket.on("deleteListBroadcast", (userId: string, listId: string, lists: Array<ProjectList>) => {
            let list = projectStateRef.current?.lists.find(l => l._id === listId);
            if (list) {
              dispatch(setLists(lists));
            }
          });

          socket.on("saveListBroadcast", (userId: string, listId: string, lists: Array<ProjectList>) => {
            let list = projectStateRef.current?.lists.find(l => l._id === listId);
            if (list) {
              dispatch(setLists(lists));
            }
          });

          socket.on("saveListObjectBroadcast", (userId: string, list: ProjectList) => {
            let lists = [...projectStateRef.current?.lists];
            let index = lists.findIndex(l => l._id === list._id);
            if (index !== -1) {
              lists[index] = {...list};
              //console.log(lists);
              dispatch(setLists(lists));
            }
          });

          socket.on("createLabelBroadcast", (userId: string, label: Label) => {
            let project = projectStateRef.current?.projects.find(p => p._id === label.projectId);
            if (project) {
              let labels = [...projectStateRef.current?.labels];
              let index = projectStateRef.current?.labels.findIndex(l => l._id === label._id);
              if (index === -1) {
                labels.push(label);
                dispatch(setLabels(labels));
                dispatch(setProjectStatus("labelAdded"));
              }
            }
          });

          socket.on("updateLabelBroadcast", (userId: string, label: Label) => {
            let labels = [...projectStateRef.current?.labels];
            let index = labels.findIndex(l => l._id === label._id);
            if (index !== -1) {
              labels[index] = {...label};
              dispatch(setLabels(labels));
            }
          });

          socket.on("saveListStatusBroadcast", (userId: string, list: ProjectList, listCards: Array<ProjectCard>) => {
            let lists = [...projectStateRef.current?.lists];
            let cards = [...projectStateRef.current?.cards];
            let index = lists.findIndex(l => l._id === list._id);
            if (index !== -1) {
              lists[index] = {...list};
              dispatch(setLists(lists));

              // Replace matching cards with ones from listCards
              const updatedCards = cards.map(card => {
                const updated = listCards.find(c => c._id === card._id);
                return updated ? updated : card;
              });

              dispatch(setCards(updatedCards));
            }
          });

          socket.on("deleteLabelBroadcast", (userId: string, labelId: string) => {
            const labels = projectStateRef.current?.labels.filter(l => l._id !== labelId);
            if (labels) {
              dispatch(setLabels(labels));
            }
          });

          socket.on("attachLabelBroadcast", (userId: string, labelToCard: LabelToCard) => {
            const card = projectStateRef.current?.cards.find(c => c._id === labelToCard.cardId);
            const label = projectStateRef.current?.labels.find(l => l._id === labelToCard.labelId);
            if (card && label) {
              let labelsToCards = [...projectStateRef.current?.labelsToCards];
              let index = labelsToCards.findIndex(lc => lc.cardId === labelToCard.cardId && lc.labelId === labelToCard.labelId);
              if (index === -1) {
                labelsToCards.push(labelToCard);
                dispatch(setLabelsToCards(labelsToCards));
                dispatch(setProjectStatus("labelAttachedToCard"));
              }
            }
          });

          socket.on("detachLabelBroadcast", (userId: string, labelId: string, cardId: string) => {
            const card = projectStateRef.current?.cards.find(c => c._id === cardId);
            const label = projectStateRef.current?.labels.find(l => l._id === labelId);
            if (card && label) {
              let labelsToCards = [...projectStateRef.current?.labelsToCards];
              let index = labelsToCards.findIndex(lc => lc.cardId === cardId && lc.labelId === labelId);
              if (index !== -1) {
                labelsToCards.splice(index, 1);
                dispatch(setLabelsToCards(labelsToCards));
              }
            }
          });

          socket.on("saveCardWorkBroadcast", (userId: string, card: ProjectCard) => {
            let cards = [...projectStateRef.current?.cards];
            let index = cards.findIndex(c => c._id === card._id);
            if (index !== -1) {
              cards[index] = {...card};
              dispatch(setCards(cards));
              dispatch(setProjectStatus("workChanged"));
            }
          });

          socket.on("saveCardOwnerBroadcast", (userId: string, card: ProjectCard) => {
            let cards = [...projectStateRef.current?.cards];
            let index = cards.findIndex(c => c._id === card._id);
            if (index !== -1) {
              cards[index] = {...card};
              dispatch(setCards(cards));
            }
          });

          socket.on("createRoadmapBroadcast", (userId: string, roadmap: Roadmap, usersWithAccess: Array<string>) => {
            if (usersWithAccess.some(u => u === userStateRef.current?._id)) {
              let roadmaps = [...roadmapStateRef.current?.roadmaps];
              let index = roadmaps.findIndex(r => r._id === roadmap._id);
              if (index === -1) {
                roadmaps.push(roadmap);
                dispatch(setRoadmaps(roadmaps));
                /* if on mobile, load the roadmap for the current user after it is created */
                if (isMobile && userId === userStateRef.current?._id) {
                  dispatch(loadRoadmap(roadmap._id));
                }
                dispatch(setRoadmapStatus("roadmapCreated"));
              }
            }
          });

          socket.on("deleteRoadmapBroadcast", (userId: string, id: string) => {
            let roadmaps = [...roadmapStateRef.current?.roadmaps];
            let index = roadmaps.findIndex(r => r._id === id);
            if (index !== -1) {
                roadmaps.splice(index, 1);
                dispatch(setRoadmaps(roadmaps));
            }
          });

          socket.on("createRoadmapCardBroadcast", (userId: string, card: RoadmapCard) => {
            let roadmap = roadmapStateRef.current?.roadmaps.find(r => r._id === card.roadmapId);
            if (roadmap) {
              let cards = [...roadmapStateRef.current?.cards];
              let index = cards.findIndex(c => c._id === card._id);
              if (index === -1) {
                cards.push(card);
                dispatch(setRoadmapCards(cards));
              }
            }
          });

          socket.on("saveRoadmapBroadcast", (userId: string, roadmap: Roadmap) => {
            let index = roadmapStateRef.current?.roadmaps.findIndex(r => r._id === roadmap._id);
            if (index !== -1) {
              let roadmaps = [...roadmapStateRef.current?.roadmaps];
              roadmaps[index] = {...roadmap};
              dispatch(setRoadmaps(roadmaps));
            }
          });

          socket.on("createCategoryBroadcast", (userId: string, category: RoadmapCategory) => {
            let roadmap = roadmapStateRef.current?.roadmaps.find(r => r._id === category.roadmapId);
            if (roadmap) {
              let categories = [...roadmapStateRef.current?.categories];
              let index = categories.findIndex(c => c._id === category._id);
              if (index === -1) {
                categories.push(category);
                dispatch(setCategories(categories));
                if (userStateRef.current?._id === userId) {
                  // only create on project
                  dispatch(setRoadmapStatus("categoryCreated"));
                }
              }
            }          
          });

          socket.on("saveCategoryBroadcast", (userId: string, category: RoadmapCategory, project: Project) => {
            let roadmap = roadmapStateRef.current?.roadmaps.find(r => r._id === category.roadmapId);
            if (roadmap) {
              let categories = [...roadmapStateRef.current?.categories];
              let cIndex = categories.findIndex(c => c._id === category._id);
              if (cIndex !== -1) {
                categories[cIndex] = {...category};
                dispatch(setCategories(categories));
              }
              let projects = [...projectStateRef.current?.projects];
              let pIndex = projects.findIndex(p => p._id === project._id);
              if (pIndex !== -1) {
                projects[pIndex] = {...projects[pIndex], name: project.name };
                dispatch(setProjects(projects));
              }
            }          
          });

          socket.on("deleteCategoryBroadcast", (userId: string, categoryId: string, projectId: string) => {
              let categories = [...roadmapStateRef.current?.categories];
              let cIndex = categories.findIndex(c => c._id === categoryId);
              if (cIndex !== -1) {
                categories.splice(cIndex,1);
                dispatch(setCategories(categories));
              }
              let projects = [...projectStateRef.current?.projects];
              let pIndex = projects.findIndex(p => p._id === projectId);
              if (pIndex !== -1) {
                projects.splice(pIndex,1);
                dispatch(setProjects(projects));
              }  
          });

          socket.on("saveRoadmapCardBroadcast", (userId: string, card: RoadmapCard) => {
            console.log(card);
            let cards = [...roadmapStateRef.current?.cards];
            let index = cards.findIndex(c => c._id === card._id);
            if (index !== -1) {
              cards[index] = {...card};
              dispatch(setRoadmapCards(cards));
            }
          });

          socket.on("deleteRoadmapCardBroadcast", (userId: string, id: string) => {
            let cards = [...roadmapStateRef.current?.cards];
            let index = cards.findIndex(c => c._id === id);
            if (index !== -1) {
              cards.splice(index, 1);
              dispatch(setRoadmapCards(cards));
            }
          });

          socket.on("deleteMemberBroadcast", (userId: string, email: string) => {
            let members = [...roadmapStateRef.current?.members];
            let index = members.findIndex(m => m.email === email);
            if (index !== -1) {
              members.splice(index, 1);
              dispatch(setMembers(members));
            }
          });

          socket.on("shareViaEmailBroadcast", (userId: string, roadmapId: string) => {
            let roadmap = roadmapStateRef.current?.roadmaps.find(r => r._id === roadmapId);
            if (roadmap) {
              dispatch(setRoadmapStatus("sharedViaEmail"));
            }
          });

          socket.on("saveMemberBroadcast", (userId: string, member: Member) => {
            let members = [...roadmapStateRef.current?.members];
            console.log("hello");
            let index = roadmapStateRef.current?.members.findIndex(m => m.email === member.email);
            if (index !== -1) {
              
              members[index] = {
                ...members[index],
                memberType: member.memberType,
                roadmap: member.roadmap,
                projectIds: member.projectIds,
                futureBoards: member.futureBoards
              };
              dispatch(setMembers(members));
            }
          });
          
          socket.on("saveAvatarBroadcast", (userId: string, avatar: string) => {
            let members = [...roadmapStateRef.current?.members];
            let index = roadmapStateRef.current?.members.findIndex(m => m.userId === userId);
            if (index !== -1) {
              members[index] = { ...members[index], avatar: avatar };
              dispatch(setMembers(members));
            }
            if (userStateRef.current?._id === userId) {
              dispatch(setAvatar(avatar));
            }
          });

          socket.on("removeAvatarBroadcast", (userId: string) => {
            let members = [...roadmapStateRef.current?.members];
            let index = roadmapStateRef.current?.members.findIndex(m => m.userId === userId);
            if (index !== -1) {
              members[index] = { ...members[index], avatar: "" };
              dispatch(setMembers(members));
            }
            if (userStateRef.current?._id === userId) {
              dispatch(setAvatar(""));
            }
          });

          return () => {
            socket.off();
          };

        });
      }
    }
  }, [userState.accessToken]);

  useEffect(() => {
    if (chatState.channels.length > 0) {
      // When channels are loaded or added, get messages
      let socket = openSocket(dispatch, settingsState);
      if (socket) {
        socket.emit("getMessages");
      }
    }
  }, [chatState.channels.length]);

/*
  useEffect (() => {
    if (userState._id !== "") {
     
    }
  }, [userState._id]);
*/
  /*
  useEffect(() => {
    io.on("connect", (socket: Socket) => {
      console.log(`User connected: ${socket.id}`);
    }
  }, [settingsState.socket]);
  */

  useEffect (() => {
    if (folderState.status === "roadmapFoldersLoaded") {
      dispatch(setFolderStatus("idle"));
      dispatch(getRoadmaps());
    }
  }, [folderState.status]);

  useEffect (() => {
    if (roadmapState.roadmaps.length > 0) {
      if (roadmapState.status !== "roadmapModeSaved") {
        let loadedRoadmap = roadmapState.roadmaps.find(r => r.loaded);
        if (loadedRoadmap) {
          //dispatch(getProjects(loadedRoadmap._id));
          dispatch(getWorkFolders(loadedRoadmap._id));
          dispatch(getMembers(loadedRoadmap._id));
          dispatch(getRoadmapCategories(loadedRoadmap._id));
          dispatch(getRoadmapCards(loadedRoadmap._id));
        }
      } else {
        dispatch(setRoadmapStatus("idle"));
      }
    }
  //}, [roadmapState.roadmaps]);
  }, [roadmapState.roadmaps.map(roadmap => roadmap.loaded).join(",")]);

  useEffect (() => {
    if (folderState.status === "workFoldersLoaded") {
      let loadedRoadmap = roadmapState.roadmaps.find(r => r.loaded);
      if (loadedRoadmap) {
        dispatch(setFolderStatus("idle"));
        dispatch(getProjects(loadedRoadmap._id));
      }
    }
  }, [folderState.status]);

  useEffect (() => {
    if (projectState.projects.length > 0 && settingsState.settings.loadedComponentType === "work") {
      let loadedProject = projectState.projects.find(p => p.loaded);
      if (loadedProject) {
        dispatch(getLists(loadedProject._id));
        dispatch(getListSettings(loadedProject._id));
        dispatch(getCards(loadedProject._id));
        dispatch(getProjectCardWorkLogEntries(loadedProject._id));
        dispatch(getLabelsToCards(loadedProject._id));
        dispatch(getLabels(loadedProject._id));
        dispatch(getComments(loadedProject._id));
      }
    }
  },  [projectState.projects.map(project => project.loaded).join(","), settingsState.settings.loadedComponentType]);
/*
  const openSocket = () => {
    if (!settingsState.socket) {
      //socket = io(process.env.REACT_APP_BACKEND_URL);
      //const newSocket = io(process.env.REACT_APP_BACKEND_URL);
      const newSocket = io(process.env.REACT_APP_BACKEND_URL, {
        transports: ["websocket"], // Force WebSocket only
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000
      });

      dispatch(setSocket(newSocket));
      //console.log(socket);
      console.log(newSocket);
    }
  }
*/
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      /> 
      <Routes>
        <Route path="" element={<Home />} />
        <Route path="/login">
          <Route path=":roadmap/:link" element={<Login />} />
          <Route path=":ac" element={<Login />} />
          <Route path="" element={<Login />} />
        </Route>
        <Route path="/register">
          <Route path=":roadmap/:link" element={<Register />} />
          <Route path="" element={<Register />} />
        </Route>
        <Route path="/recover">
          <Route path=":ar" element={<Recover />} />
          <Route path="" element={<Recover />} />
        </Route>
        <Route path="/roadmap/invite/">
          <Route path=":roadmap/:link" element={<RoadmapInvite />} />
        </Route>
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/products' element={<Products />} />
        <Route path='/why-herdr' element={<WhyHerdr />} />
        <Route path='/team' element={<Team />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/remote-teams' element={<RemoteTeams />} />
        <Route path='/tech-startup-founders' element={<TechStartupFounder />} />
        <Route path='/creative-agencies' element={<CreativeAgency />} />
        <Route path='/freelancers' element={<Freelancer />} />
        <Route path='/product-designers' element={<ProductDesigner />} />
        <Route path='/bootstrapped-entrepreneurs' element={<BootstrappedEntrepreneur />} />
        <Route path='/small-nonprofits' element={<NonProfit />} />
        <Route path='/academic-research-teams' element={<AcademicResearchTeam />} />
        <Route path='/software-development-teams' element={<SoftwareDevelopmentTeam />} />
        <Route path='/consultants-coaches' element={<ConsultantCoach />} />
        <Route path='/ecommerce-teams' element={<EcommerceTeam />} />
        <Route path='/company-executives' element={<CompanyExecutives />} />
        <Route path='/forgot' element={<Forgot />} />
        <Route path='/dash' element={<Dash />} />
        <Route path='*' element={<NotFound404 />} />
      </Routes>
      <Mouseflow />
    </Router>
  );
}

export default App;
